import { Laptop, Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { Button } from "@/components/ui/button";

const order = ["system", "light", "dark"] as const;

export function ThemeToggle() {
  const { theme = "system", setTheme } = useTheme();
  const next = order[(order.indexOf(theme as (typeof order)[number]) + 1) % order.length];
  const Icon = theme === "dark" ? Moon : theme === "light" ? Sun : Laptop;
  return (
    <Button variant="ghost" size="icon" onClick={() => setTheme(next)} aria-label={`Theme: ${theme}. Switch to ${next}.`} title={`Theme: ${theme}`}>
      <Icon className="size-4" />
    </Button>
  );
}
